import { render } from "./handle_sso_login.html?vue&type=template&id=1d51f0c2&external"
import script from "./handle_sso_login.js?vue&type=script&lang=js&external"
export * from "./handle_sso_login.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__